export default "__VITE_ASSET__Dq9TOI4a__"